<template>
    <div class="modal">
        <div class="modal__container">
            <div class="modal__inner modal__inner--secondary">
                <h4 class="modal__ttl modal__ttl--primary">
                    Adjacent seats are not available
                </h4>

                <div class="modal__content">
                    <div class="content">
                        <p>We were unable to find {{ activeTicket.qty }} adjacent seats for you.</p>
                        <p class="mt-5">Do you still want to book these seats?</p>
                    </div>

                    <button class="btn btn--secondary mr-3" @click.prevent="close">
                        <span>{{ __("Cancel") }}</span>
                    </button>

                    <button class="btn btn--quaternary" @click.prevent="accept">
                        <span>{{ __("Add to Basket") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "seat-picker-ticket-variant-seated-adjacent-unavailable-modal",
    props: {
        activeTicket: {
            type: Object,
            default: false
        }
    },
    data: instance => {
        return {
        };
    },
    methods: {
        accept() {
            this.$emit("accept", this.activeTicket);
        },
        close() {
            // reloading the page because available ticket qty has been changed in the parent component but they have now cancelled
            window.location.reload();
            // this.$emit("close", true);
        }
    }
};
</script>
<style lang="scss" scoped>
.mb-5 {
    margin-bottom: 1.25rem;
}
.mt-7 {
    margin-bottom: 1.75rem;
}
.mr-3 {
    margin-right: 0.75rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.modal__content {
    text-align: center;
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.9);

    .content {
        color: #000;
        max-height: 65vh;
        overflow-y: auto;
        padding: 20px;
        margin-bottom: 10px;
    }
}
h4 {
    &.modal__ttl--primary {
        font-size: 24px;
    }
}
.modal__close {
    margin-top: 40px;
}
option {
    color: #000;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPickerTicketVariantSeatedAdjacentUnavailableModal.vue